module.exports = __webpack_public_path__ + "static/media/check-box-ic-checked.d286e3df.svg";